module.exports = __webpack_public_path__ + "static/viddl_logo-5e467e5dcf6271a9d0d535707798772a.png";